import {Component} from "@angular/core";
import {Token, TokenService} from "../../../../../services/token.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {RevokeTokenModalComponent} from "./modals/revoke-token-modal/revoke-token-modal.component";
import {ViewTokenModalComponent} from "./modals/view-token-modal/view-token-modal.component";
import {CreateTokenModalComponent} from "./modals/create-token-modal/create-token-modal.component";
import {HelpersService} from "../../../../../services";

@Component({
  selector: 'app-token-management',
  templateUrl: './token-management.component.html',
  styleUrls: ['./token-management.component.scss']
})

export class TokenManagementComponent {
  tokens: Token[] = [];
  partnerId: string; // Set this based on the selected store

  constructor(private tokenService: TokenService, private modalService: NgbModal, ) {}

  ngOnInit(): void {
    this.loadTokens();
  }

  loadTokens(): void {
    if (this.partnerId){
      this.tokenService.getTokens(this.partnerId).subscribe((tokens) => {
        this.tokens = tokens;
      });
    }


  }

  openCreateTokenModal(): void {
    const modalRef = this.modalService.open(CreateTokenModalComponent);
    modalRef.result.then((result) => {
      if (result) {
        this.partnerId = result.partnerId;
        this.tokenService.createToken(result.partnerId, result.Name, result.Expiry).subscribe(() => {
          this.loadTokens();
        });
      }
    });
  }

  openViewTokenModal(token): void {
    this.tokenService.viewTokens(this.partnerId, token.tokenId ).subscribe((token: any) => {
      const modalRef = this.modalService.open(ViewTokenModalComponent)
      modalRef.componentInstance.token = token;
    });



  }

  openRevokeTokenModal(tokenId: string): void {
    const modalRef = this.modalService.open(RevokeTokenModalComponent);
    modalRef.result.then((result) => {
      if (result === 'revoke') {
        this.tokenService.revokeToken(this.partnerId, tokenId ).subscribe(() => {
          this.loadTokens();
        });
      }
    });
  }
}
